import { createFileRoute } from '@tanstack/react-router';
import { CancelAutoRenewPage } from '../../pages/cancel-auto-renew';

export const Route = createFileRoute('/_app/cancel-auto-renew')({
	component: CancelAutoRenewPage,
});
